var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 26.876 26.876"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 82741"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h26.876v26.876H0Z",
    "data-name": "Path 48467"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    "data-name": "Group 82738"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.437 20.438a1 1 0 0 1-.707-1.707l12-12a1 1 0 0 1 1.414 1.414l-12 12a1 1 0 0 1-.707.293",
    "data-name": "Path 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.437 20.438a1 1 0 0 1-.707-.293l-12-12a1 1 0 0 1 1.414-1.414l12 12a1 1 0 0 1-.707 1.707",
    "data-name": "Path 33"
  })))));
};
export default SvgClose;